module.exports = __webpack_public_path__ + "fonts/ApercuPro-Regular.2a38115.woff2";